module.exports = __webpack_public_path__ + "static/media/1024294.714d139f.jpg";